import noData from '../../../../assets/icons/charts/nodata-chart.svg';
import { Contact } from '../../../../shared/constants/contact';
import {
  WidgetErrorState,
  WidgetType,
} from '../../../../shared/constants/widget';

interface INoDataprops {
  errorType?: WidgetErrorState;
  type?: any;
}

function NoData({ errorType, type }: INoDataprops) {
  let sizeClass: string;

  const smallTypes = [WidgetType.FLASH_CARD, WidgetType.ICON_CARDS];
  const mediumTypes = [
    WidgetType.BENCHMARK_SCORE_CARD,
    WidgetType.SCORE_INFO_CARD,
  ];

  if (smallTypes.includes(type)) {
    sizeClass = 'min-h-[150px]';
  } else if (mediumTypes.includes(type)) {
    sizeClass = 'min-h-[248px]';
  } else {
    sizeClass = 'min-h-[413px]';
  }

  return (
    <div
      className={`m-auto grid rounded-2xl bg-white ${sizeClass} h-full content-center justify-center`}
    >
      <div className="text-center">
        <img src={noData} className="mx-auto mb-8 h-auto w-8" alt="" />
        <p className="text-grey-500 px-4 text-sm text-pretty">
          {errorType === WidgetErrorState.EMPTY ? (
            'There’s not enough recent data to display insights right now.'
          ) : errorType === WidgetErrorState.API_FAIL ? (
            <>
              Sorry, we can't display the data for this widget. Please get in
              touch with us at{' '}
              <a
                href={`mailto:${Contact.Email}`}
                className="font-semibold text-blue-700"
              >
                {Contact.Email}
              </a>
            </>
          ) : (
            'No data to show for fewer than 5 active users'
          )}
        </p>
      </div>
    </div>
  );
}

export default NoData;
